import { ExportCSVData } from "components/controls/ExportDialog"
import { filter } from "./utils"
import metaSo from ".."
import querySo from "stores/route/query"
import farmSo from "stores/farm"
import dayjs from "dayjs"
import { URL_PAR } from "stores/route/utils/types"
import valuesSo from "stores/values"



/** per l'export in CSV tramite url*/
export function getExportDataUrl() {
	const [filterText, group, service, feature] = querySo.getSearchUrl([
		URL_PAR.TEXT, URL_PAR.META_GROUP, URL_PAR.META_SERVICE, URL_PAR.META_FEATURE
	]) as string[]
	return getExportData(filterText, group, service, feature)
}

/** per l'export in CSV */
export function getExportData(filterText: string, group: string, service: string, feature: string): ExportCSVData {
	let items = filter(metaSo.state.metadata, filterText, group, service, feature)
	items = querySo.getSorted({ items })
	const data = items.map(item => [
		item.name, item.serviceCode, item.description,
		item.alias, item.target, item.group,
		item.um, item.type,
		item.min?.toString() ?? "",
		item.max?.toString() ?? "",
		item.readOnly ? "YES" : "NO",
		item.graph ? "YES" : "NO",
		valuesSo.getByAlias({ alias: item.alias, code: item.serviceCode }),
	])
	return {
		headers: [
			"NAME", "SERVICE CODE", "DESCRIPTION",
			"ALIAS", "TARGET", "GROUP",
			"UNIT OF MEASURE", "TYPE", "MIN",
			"MAX", "READ ONLY", "IS METRIC",
			"VALUES"
		],
		items: data,
		fileName: `METADATA ${farmSo.state.select.name} (${dayjs().format("YYYY-MM-DD HH-mm")})`
	}
}